import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import ImageWithSrcSet from "components/ui/ImageWithSrcSet"
import { ImageData } from "types/interfaces"

import * as Styled from "./styles"

export const data = graphql`
  query MyQuery {
    markdownRemark(frontmatter: { category: { eq: "mockup" } }) {
      frontmatter {
        largeImage {
          childImageSharp {
            gatsbyImageData
          }
        }
        smallImage {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`

const Mockup: React.FC = () => {
  const { markdownRemark } = useStaticQuery(data)
  const imageData: ImageData = markdownRemark.frontmatter

  return (
    <Styled.MockupWrapper>
      <ImageWithSrcSet data={imageData} />
    </Styled.MockupWrapper>
  )
}

export default Mockup
